import React, { useState, useEffect, useRef } from "react";
import { SpeedDial } from "primereact/speeddial";
import { Toast } from "primereact/toast";
import { useNavigate } from "react-router-dom";
import { Button } from "primereact/button";
import { OverlayPanel } from "primereact/overlaypanel";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import { getUserData } from "./utils/localStorage";
import { storeOrdersWithPaginationAndSearch } from "./services/StoreOrder/StoreOrder";

const ButtonLink = () => {
  const navigate = useNavigate();

  const { storeData, userProfileRole, brandProfileData, userProfileData } =
    getUserData();

  const storeId = storeData.id;
  const userRole = userProfileRole;
  let brandId = brandProfileData.id;

  const toast = useRef(null);
  const toast2 = useRef(null);
  const op = useRef(null);

  const [customerALLOrdersData, setCustomerALLOrdersData] = useState([]);
  const [page, setPage] = useState(0);

  const invoiceBodyTemplate = (rowData) => {
    return (
      <div
        className="cursor-pointer"
        onClick={() =>
          userRole === "BY_ADMIN" || userRole === "BY_SUB_ADMIN_USER"
            ? navigate("/OrdersGarmentInfo", {
                state: {
                  storeIdValue: rowData.storeId,
                  bookingOrderId: rowData.id,
                  storeCustomerId: rowData.storeCustomerId,
                },
              })
            : navigate("/OrdersGarmentInfo", {
                state: {
                  bookingOrderId: rowData.id,
                  storeCustomerId: rowData.storeCustomerId,
                },
              })
        }
      >
        <span style={{ color: "blue", textDecoration: "underline" }}>
          {rowData?.invoiceNo}
        </span>
      </div>
    );
  };

  const customerBody = (rowData) => rowData.customerName?.replace(/_/g, " ");

  const [searchTerm, setSearchTerm] = useState("");

  const fetchStoreOrders = (data) => {
    storeOrdersWithPaginationAndSearch(storeId, {
      ...data,
      sortOrder: "asc",
      sortBy: "id",
      limit: 1,
      offset: page * 1, // Ensure offset is correctly applied
    })
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;

          setCustomerALLOrdersData(Res); // Reset state with new data
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  const searchTermApiCall = (text) => {
    if (text !== "") {
      //   setSearchTerm(text);
      setPage(0);
      const requestValue = {
        // ...requestData,
        storeIds: [storeId],
        brandId: brandId,
        recordType: "",
        statusIn: [
          "BOOKED",
          "INPROCESS",
          "IN_WAREHOUSE",
          "PROCESSED",
          "DELIVERED",
          "DONE",
          "CANCEL",
          "UNPROCESSED",
          "OUT_FOR_DELIVERY",
          "DELAY_STATUS",
        ],
        startDate: null,
        endDate: null,
        offset: 0,
        searchBy: "INVOICE",
        searchText: text,
      };
      fetchStoreOrders(requestValue);
    } else {
      //   setSearchTerm("");
      setCustomerALLOrdersData([]);
      setPage(0);
    }
  };

  const items = [
    {
      label: "Search Products",
      icon: "pi pi-search",
      // command: (e) => op.current.toggle(e.originalEvent),
    },
    {
      label: "Order",
      icon: "pi pi-list",
      command: () => navigate("/Orders"),
    },
    {
      label: "Home",
      icon: "pi pi-home",
      command: () => navigate("/"),
    },
  ];

  const [isOpen, setIsOpen] = useState(false);

  const toggleSpeedDial = () => {
    setIsOpen((prev) => !prev);
  };

  return (
    <>
      <Toast ref={toast} />
      <Toast ref={toast2} />
      <div
        className={`speeddial-bottom-left p-speeddial p-component p-speeddial-linear p-speeddial-direction-up ${
          isOpen ? "p-speeddial-opened" : ""
        }`}
        style={{
          alignItems: "center",
          flexDirection: "column-reverse",
          position: "fixed",
          bottom: 10,
          right: 20,
          zIndex: 1000,
          display: "flex",
        }}
      >
        <button
          className="p-button-help border-circle p-0 p-speeddial-button p-button-rounded p-button p-component p-button-icon-only"
          type="button"
          aria-expanded={isOpen}
          aria-haspopup="true"
          onClick={toggleSpeedDial}
        >
          <span
            className={`pi ${isOpen ? "pi-times" : "pi-arrow-circle-right"}`}
          ></span>
          <span className="p-button-label p-c">&nbsp;</span>
        </button>

        <ul
          className="p-speeddial-list"
          role="menu"
          tabIndex="-1"
          style={{
            display: isOpen ? "flex" : "none",
            flexDirection: "column-reverse",
          }}
        >
          <li
            className="p-speeddial-item"
            role="menuitem"
            style={{ transitionDelay: "160ms" }}
          >
            <a
              onClick={() => navigate("/")}
              role="menuitem"
              className="p-speeddial-action cursor-pointer"
              aria-label="Home"
              tabIndex="-1"
              data-pr-tooltip="Home"
            >
              <span className="p-speeddial-action-icon pi pi-home"></span>
            </a>
          </li>
          <li
            className="p-speeddial-item"
            role="menuitem"
            style={{ transitionDelay: "80ms" }}
          >
            <a
              onClick={() => navigate("/Orders")}
              role="menuitem"
              className="p-speeddial-action cursor-pointer"
              aria-label="Order"
              tabIndex="-1"
              data-pr-tooltip="Order"
            >
              <span className="p-speeddial-action-icon pi pi-list"></span>
            </a>
          </li>
          <li
            className="p-speeddial-item"
            role="menuitem"
            style={{ transitionDelay: "0ms" }}
          >
            <a
              onClick={(e) => op.current.toggle(e)}
              role="menuitem"
              className="p-speeddial-action cursor-pointer"
              aria-label="Search Products"
              tabIndex="-1"
              data-pr-tooltip="Search Products"
            >
              <span className="p-speeddial-action-icon pi pi-search"></span>
            </a>
          </li>
        </ul>
      </div>

      <div style={{ display: "none" }}>
        <SpeedDial
          model={items}
          direction="up"
          transitionDelay={80}
          showIcon="pi pi-arrow-circle-right"
          hideIcon="pi pi-times"
          className="speeddial-bottom-left left-0 bottom-0"
          buttonClassName="p-button-help border-circle p-0"
        />
      </div>

      {/* Overlay panel and datatable always in DOM */}
      <OverlayPanel ref={op} showCloseIcon closeOnEscape dismissable>
        <div className="flex-1 flex justify-content-center gap-3">
          <IconField iconPosition="left" className="flex flex-1">
            <InputIcon className="pi pi-search text-xl"> </InputIcon>
            <InputText
              placeholder={"Search By Invoice No."}
              value={searchTerm}
              keyboardType={"default"}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="text-xl flex flex-1 py-1 px-5"
              style={{ borderRadius: 30 }}
            />
          </IconField>
          <Button label="Go" onClick={() => searchTermApiCall(searchTerm)} />
        </div>
        <DataTable
          value={customerALLOrdersData}
          selectionMode="single"
          paginator
          rows={1}
        >
          <Column
            field="invoiceNo"
            header="Invoice No"
            body={invoiceBodyTemplate}
            style={{ minWidth: "12rem" }}
          />
          <Column
            field="customer"
            header="Customer Name"
            body={customerBody}
            style={{ minWidth: "8rem" }}
          />
        </DataTable>
      </OverlayPanel>
    </>
  );
};

export default ButtonLink;
